var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboardGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 241 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 6.00003H8.00006C6.89547 6.00003 6.00003 6.89547 6.00003 8.00006V10.6668C6.00003 11.7714 6.89547 12.6668 8.00006 12.6668H10.6668C11.7714 12.6668 12.6668 11.7714 12.6668 10.6668V8.00006C12.6668 6.89547 11.7714 6.00003 10.6668 6.00003ZM8.00006 4C5.79089 4 4 5.79089 4 8.00006V10.6668C4 12.8759 5.79089 14.6668 8.00006 14.6668H10.6668C12.8759 14.6668 14.6668 12.8759 14.6668 10.6668V8.00006C14.6668 5.79089 12.8759 4 10.6668 4H8.00006Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 243 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 19.3335H8.00006C6.89547 19.3335 6.00003 20.229 6.00003 21.3336V24.0003C6.00003 25.1049 6.89547 26.0003 8.00006 26.0003H10.6668C11.7714 26.0003 12.6668 25.1049 12.6668 24.0003V21.3336C12.6668 20.229 11.7714 19.3335 10.6668 19.3335ZM8.00006 17.3335C5.79089 17.3335 4 19.1244 4 21.3336V24.0003C4 26.2094 5.79089 28.0003 8.00006 28.0003H10.6668C12.8759 28.0003 14.6668 26.2094 14.6668 24.0003V21.3336C14.6668 19.1244 12.8759 17.3335 10.6668 17.3335H8.00006Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 242 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0008 6.00003H21.334C20.2295 6.00003 19.334 6.89547 19.334 8.00006V10.6668C19.334 11.7714 20.2295 12.6668 21.334 12.6668H24.0008C25.1053 12.6668 26.0008 11.7714 26.0008 10.6668V8.00006C26.0008 6.89547 25.1053 6.00003 24.0008 6.00003ZM21.334 4C19.1249 4 17.334 5.79089 17.334 8.00006V10.6668C17.334 12.8759 19.1249 14.6668 21.334 14.6668H24.0008C26.2099 14.6668 28.0008 12.8759 28.0008 10.6668V8.00006C28.0008 5.79089 26.2099 4 24.0008 4H21.334Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 244 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0008 19.3335H21.334C20.2295 19.3335 19.334 20.229 19.334 21.3336V24.0003C19.334 25.1049 20.2295 26.0003 21.334 26.0003H24.0008C25.1053 26.0003 26.0008 25.1049 26.0008 24.0003V21.3336C26.0008 20.229 25.1053 19.3335 24.0008 19.3335ZM21.334 17.3335C19.1249 17.3335 17.334 19.1244 17.334 21.3336V24.0003C17.334 26.2094 19.1249 28.0003 21.334 28.0003H24.0008C26.2099 28.0003 28.0008 26.2094 28.0008 24.0003V21.3336C28.0008 19.1244 26.2099 17.3335 24.0008 17.3335H21.334Z",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardGray);
export default __webpack_public_path__ + "static/media/iconDashboardGray.fd94cc12cdfda98cc9721d26493baec9.svg";
export { ForwardRef as ReactComponent };